import React from 'react';
import { classNames } from '../../../utils';
import { INotificationContainerProps, Position } from '../types';

const POSITION_MAP: Record<Position, string> = {
  [Position.BOTTOM_LEFT]: 'bottom-4 left-4',
  [Position.BOTTOM_CENTER]: 'bottom-4 left-1/2 transform -translate-x-1/2',
  [Position.BOTTOM_RIGHT]: 'bottom-4 right-4',
  [Position.TOP_LEFT]: 'top-4 left-4',
  [Position.TOP_CENTER]: 'top-4 left-1/2 transform -translate-x-1/2',
  [Position.TOP_RIGHT]: 'top-4 right-4',
};

const NotificationContainer = ({
  hasNotification,
  position,
  className = undefined,
  children,
}: INotificationContainerProps): JSX.Element => {
  return (
    <div
      className={classNames(
        'box-border max-w-full max-h-full fixed overflow-hidden p-2 z-50',
        hasNotification ? '' : 'pointer-events-none',
        POSITION_MAP[position],
        className ? className : '',
      )}
    >
      {children}
    </div>
  );
};

export default NotificationContainer;
